import { store } from 'react-notifications-component';

export function makeAlert(type, message, duration = 3000) {
  store.addNotification({
    message: message,
    type: type,
    insert: 'top',
    container: 'bottom-center',
    animationIn: ['animated', 'fadeInUp'],
    animationOut: ['animated', 'fadeOutDown'],
    dismiss: {
      duration,
      onScreen: false
    }
  });
}
